import html2canvas from 'html2canvas';
import $ from 'jquery';
import { addParam, getOpenDocumentLink } from '../utils/general/general';

export const captureAndCopyScreenshotWithHtml = async () => {
    try {
        const figure = $('#right-pane .fg.carousel-item.active div');
        const location: any = figure.attr("data-name");
        const selectedFigure = figure.get(0); // Get the DOM element
        let docLink = getOpenDocumentLink(window.HTML_RENDITION.initialData.doc_id);
        docLink = addParam(docLink, 'anchor', location);

        const linkText = Base64.decode(window.HTML_RENDITION.initialData.doc_headline);

        const canvas = await html2canvas(selectedFigure);
        const dataUrl = canvas.toDataURL('image/png');

        const htmlContent = `
                <div>
                 <a href="${docLink}">
                    <img src="${dataUrl}" alt="Screenshoted div converted to image" />
                 </a>   
                    <br />
                    <a href="${docLink}">${linkText}</a>
                </div>
            `; 
        const htmlBlob = new Blob([htmlContent], { type: 'text/html' });

        const clipboardItem = new ClipboardItem({
            [htmlBlob.type] : htmlBlob
        });
        
        await navigator.clipboard.write([clipboardItem]);
        console.log('Image and HTML content copied to clipboard');
        showTooltip();
    } catch (error) {
        console.error(`Failed to copy figure ${location} to clipboard : `, error);
    }
};

function showTooltip() {
    $('.copy-figure-tooltip').addClass('show');
    setTimeout(hideTooltip, 1000);
}

// Function to hide the tooltip
function hideTooltip() {
    $('.copy-figure-tooltip').removeClass('show');
}